import { ChatCartPaid } from "components/icons/Chat/ChatCartPaid";
import CustomerFeedbackIcon from "static/images/CustomerFeedback.svg";

export const CustomerFeedbackCardHeader = ({
  isSubmitted,
  header,
}: {
  isSubmitted: boolean;
  header: string;
}) => (
  <div className="t-flex t-items-center t-gap-1.5">
    {isSubmitted ? (
      <ChatCartPaid />
    ) : (
      <img src={CustomerFeedbackIcon} alt="CustomerFeedbackIcon" />
    )}
    <span className="t-text-subtitle-sm t-text-text-30">{header}</span>
  </div>
);
